import React, { useEffect, useState } from 'react';
import { authUiBus, ModalPayload } from './authUiBus';

/**
 * AuthErrorModal
 * --------------
 * Mounted ONCE at the app root. Listens on the auth UI bus and renders a
 * blocking modal for terminal authentication failures. On OK it invokes the
 * payload's callback (which logs the user out).
 */
export const AuthErrorModal: React.FC = () => {
  const [payload, setPayload] = useState<ModalPayload | null>(null);

  useEffect(() => authUiBus.onModal((p) => setPayload(p)), []);

  if (!payload) {
    return null;
  }

  const handleOk = () => {
    const cb = payload.onOk;
    setPayload(null);
    cb?.();
  };

  return (
    <div style={overlay} role="dialog" aria-modal="true" data-testid="auth-error-modal">
      <div style={box}>
        <h3 style={{ margin: 0 }}>{payload.title}</h3>
        <p>{payload.message}</p>
        {payload.correlationId && (
          <p style={{ fontSize: 12, color: '#666' }}>Reference ID: {payload.correlationId}</p>
        )}
        <button onClick={handleOk} style={btn} data-testid="auth-error-modal-ok">
          OK
        </button>
      </div>
    </div>
  );
};

const overlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};
const box: React.CSSProperties = {
  background: '#fff',
  padding: 24,
  borderRadius: 8,
  maxWidth: 420,
  textAlign: 'center',
};
const btn: React.CSSProperties = {
  marginTop: 12,
  padding: '8px 24px',
  border: 'none',
  borderRadius: 4,
  background: 'rgba(175, 45, 148, 1)',
  color: '#fff',
  cursor: 'pointer',
};

export default AuthErrorModal;
